<template>
  <!-- 测评答题组件 -->
  <div v-if="list && list.length>0" class="answer-questions">
    <!-- 选题模块 -->
    <div class="questions-container">
      <!-- 进度 -->
      <div v-if="!isPattern && !isTitle" class="questions-progress">
        <label>{{list[optionIndex]['optionCount']}}/{{questionCount}}</label>
        <div class="progress">
          <van-progress
            :percentage="percentage"
            :show-pivot="false"
            color="#EB5032"
            style="height:5px;border-radius:5px;"
          />
        </div>
      </div>
      <!-- 题目 -->
      <div v-if="!isPattern">
        <div v-for="(item,index) in list" :key="index" class="questions-title">
          <ul v-if="optionIndex==index">
            <li class="title">{{item.question}}</li>
            <van-radio-group
              v-if="isArray(item.options).length>0"
              v-model="selectQuestionArray[index]"
            >
              <van-radio
                @click="selectQuestions(itemOption)"
                :class="['radio',itemOption[1]==selectQuestionArray[index]?'on':false]"
                v-for="(itemOption,indexOption) in isArray(item.options)"
                :key="indexOption"
                :name="itemOption[1]"
              >{{itemOption[0]}}</van-radio>
            </van-radio-group>
          </ul>
        </div>
      </div>

      <!-- 下一步 -->
      <div class="btn-group-on">
        <button
          v-if="isTitle && optionIndex>0"
          class="previousBtn-on"
          @click="previousHandle()"
        >上一题</button>
        <button
          v-if="list[optionIndex]&& isArray(list[optionIndex].options).length==0"
          class="nextBtn"
          :style="optionIndex==0?'margin-left:0;':''"
          @click="nextHandle()"
        >下一步</button>
      </div>

    </div>
    <!-- 按钮 -->
    <div class="btn-group">
      <button
        v-if="list[optionIndex] &&isArray(list[optionIndex].options).length>0 && optionIndex>0 && !isPattern"
        class="previousBtn"
        @click="previousHandle()"
      >上一题</button>
      <button v-if="isNextQuest" class="nextBtn" :style="optionIndex==0?'margin-left:0;':''" @click="toSheet()">下一题</button>
      <!-- <button v-if="isRepoer" class="reportBtn" @click="saveQuestionsHandle()">生成报告</button> -->
    </div>
    <p class="small">新精英生涯提供内容与技术支持</p>
    <!-- 答题页说明 -->
    <answer-sheet
      :sheet_list="sheetList"
      :btnText = "btnText"
      :title="title"
      :class="['answer-sheet',!answerSheetShow?'on':'']"
      @answerBoolhandle="answerBoolhandle"
    ></answer-sheet>
    <!-- 继续答题 -->
    <van-popup  v-model="interruptShow" :close-on-click-overlay="false">
        <div class="confirm_box">
            <h2>是否从上次中断的位置继续答题？</h2>
            <div class="btn_group">
                <a class="confirm on" href="javascript:;" @click="isGetStorage(false)">重做</a>
                <a class="cancel" href="javascript:;" @click="isGetStorage(true)">继续答题</a>
            </div>
        </div>
    </van-popup>
  </div>
</template>

<script>
import AnswerSheet from "./answer-sheet";
import { saveData,getData} from '@/api/measurement'
import { progress} from '@/api/measurement_system'
import { getStorage, setStorage, deleteStorage} from '@/utils/tools'
export default {
  data() {
    return {
      selectQuestionArray: [],
      optionIndex: 0,
      answerSheetShow: true,
      questionCount:0,
      // 答题说明页数据
      sheetList: [],
      btnText:'',
      // 是否完成他评
      isCompleteBool:false,
      bool:true,
      // 定时更新测评进度
      ms_progress:null,
      // 答题数据参数
      array:[],
      data_:{},
      interruptShow:false,
      title:'',
      intro:[],
      // 存储测评对应的路由
      path:'',
      cid:null,
      // 存储回退几步
      blackNum:0,
      // 存储答题进度
      questObj:{},
      index:null,
      // 存储未答完题下标
      no_section:[],
      // 是否答完题状态
      boolQes:true,
      // 路由模块下标
      routeIdx:null
    };
  },
  computed: {
    // 判断是否有下一题
    isNextQuest(){
      if(this.list && this.list[this.optionIndex]){
        let item = this.list[this.optionIndex];
        return this.questObj[`${item.cid}${item.id}`]
      }
      return false
    },
    isTitle(){
       return  this.list && this.list[this.optionIndex] && this.isArray(this.list[this.optionIndex].options).length==0 
    },
    /*
     *@param:
     *@return:
     *@Description: 计算百分比
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-31 18:08:31
     */
    percentage() {
      if(this.list && this.list.length>0){
       return this.optionIndex + 1 == this.list.length
        ? 100
        : (this.optionIndex / this.list.length) * 100;
      }
      return 0
        
    },
    /*
     *@param: arr
     *@return: arr || []
     *@Description: 判断当前是否是数组，如果不是则显示下一个并且返回空数组，否则返回数组
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-31 16:12:10
     */
    isArray() {
      return arr => (arr instanceof Array ? arr : []);
    }
  },
  components: {
    AnswerSheet
  },
  methods: {
    /*
     *@param:
     *@return:
     *@Description:打完最后一题点击下一题触发
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2020年5月21日 11点49分
     */
    toSheet(){
      if(this.list.length-1==this.optionIndex){
        this.isRepoer();
      }else{
        this.optionIndex++ && this.blackNum--;
      }
      
    },
    /*
     *@param:bool 页面销毁时传入true
     *@return:
     *@Description: 是否答完最后一题
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-01 15:04:35
     */
    isRepoer(desBool) {
      if(desBool){
        this.saveData_();
        
      }else if(this.list && this.list.length>0){
        let bool = (
          this.optionIndex + 1 == this.list.length &&
          this.selectQuestionArray[this.optionIndex] && 
          !this.pattern
        );
        // 如果此模块答完 begin
        let b = true;
        let num = 0;
        for(let i =0;i<this.list.length;i++){
          if(!this.questObj[parseInt(`95${this.list[i].id}`)]){
            num++;
            b = false;
          }
          
        }
        if(num>0){
          this.$set(this.questObj,`${this.index}percent`,(((this.list.length-num)/this.list.length)*100).toFixed(2));
        }
        // 如果此模块答完 end
        if(bool && b){
          this.questObj['idx'+this.routeIdx] = true;
          // 存储答题缓存
          setStorage(this.path,'idx'+this.routeIdx,true);
          this.saveData_();
          this.boolQes = false;
          // 页面销毁时不提示
          if(!desBool){
            this.$toast({
              message:'恭喜你已答完本模块的题目！',
              type:'success',
              onClose:()=>{
                this.$router.go(-1);
              }
            });
          }
          
        }
        return 
      }
      return false;
    },
    /*
     *@param: bool
     *@return: 
     *@Description: 监听开始答题按钮点击
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-04 09:57:05
    */
    answerBoolhandle(bool){
      this.answerSheetShow = bool;
    },
    /*
     *@param: 
     *@return: 
     *@Description: 提交他评答题数据
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-05 11:36:56
    */
    saveHeReviewHandle(){
      let arr = [],
        count = 0;
      this.list.forEach((item, index) => {
        if (item.options && this.selectQuestionArray[index]) {
          this.$set(arr, count, {
            qid: item.id,
            eid: item.eid,
            cid: item.cid,
            score: this.selectQuestionArray[index]
          });
          count++;
        }
      });
      this.$emit("saveHeReview", arr);
    },
    /*
     *@return:函数 saveReportHandle，参数 arr
     *@Description: 提交答题结果生成报告
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-01 11:11:28
     */
    saveQuestionsHandle() {
      let arr = [],
        count = 0;
      this.list.forEach((item, index) => {
        if (item.options && this.selectQuestionArray[index]) {
          this.$set(arr, count, {
            qid: item.id,
            eid: item.eid,
            cid: item.cid,
            score: this.selectQuestionArray[index]
          });
          count++;
        }
      });
      // this.$emit("saveReportHandle", arr);
      // 销毁定时器
      window.clearInterval(this.ms_progress);
    },
    /*
     *@param:
     *@return:
     *@Description: 选中答案
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-31 17:58:31
     */
    selectQuestions(selectArr) {
      if (this.selectQuestionArray[this.optionIndex] && this.bool) {
        this.bool=false;
        let item  = this.list[this.optionIndex];
        if(!this.pattern){
          // 如果没选中值
          if(!selectArr[1]){
            this.$toast('未选中选项，请重新选择！');
            return
          }
          // 存储答题缓存
          setStorage(this.path,`${item.cid}${item.id}`,selectArr[1]);
          this.questObj[`${item.cid}${item.id}`] = selectArr[1];
          // 存储答题进度
          let storage = getStorage(this.path,this.routeIdx+'percent');
          let bfb = ((this.list[this.optionIndex]['optionCount']/this.questionCount)*100).toFixed(2);
          this.questObj[this.routeIdx+'percent'] = bfb?bfb:storage;
          setStorage(this.path,this.routeIdx+'percent',bfb?bfb:storage);
          this.isRepoer();
        }
        // 当前下标小于数组总长度
        if(this.optionIndex + 1 < this.list.length){
          // 延时等待css效果执行
          setTimeout(()=> {
            // 数组的下标
            this.optionIndex++;
            // 如果选中了答案，回退步数减一
            if(this.blackNum>0){
              this.blackNum--;
            }
            // 判断是否第二次未选择题目数组
            if(this.no_section.length>0){
              this.no_section.splice(0,1)
            }

            this.bool = true;
          },600);
        } else {
          this.bool = true;
        }
        let is_complete = (this.optionIndex == this.list.length - 1) ? true : false;
        // 神策统计--选择选项时触发
        sensors.track('doQuestions', {
          evaluation_id: this.data_.cid,
          evaluation_name: this.data_.headtitle,
          questions_number: this.data_.progress += 1,
          questions_topic: item.question,
          questions_option: selectArr[0],
          is_complete_question: is_complete,
          share_user_id: this.$route.query.share_uid || "",
          channel_name: this.$route.query.channel || ""
        });
      }
    },
    /*
     *@param:
     *@return:
     *@Description: 下一步
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-31 17:04:35
     */
    nextHandle() {
      // 如果当前没有选中只有标题就给赋值为空字符串
      this.selectQuestionArray[this.optionIndex] = "";
      // 获得当前题目的对象
      let item  = this.list[this.optionIndex];
      // 存储答题缓存,如果是标题值就存  'title'
      setStorage(this.path,String(item.cid) + String(item.id),'title');
      this.questObj[String(item.cid) + String(item.id)] ='title';
      // 存储答题进度
      let storage = getStorage(this.path,this.routeIdx+'percent');
      let bfb = ((this.list[this.optionIndex]['optionCount']/this.questionCount)*100).toFixed(2);
      this.questObj[this.routeIdx+'percent'] =bfb?bfb:storage;
      setStorage(this.path,this.routeIdx+'percent',bfb?bfb:storage);
      this.isRepoer();
      this.optionIndex++;
    },
    /*
     *@param:
     *@return:
     *@Description: 上一题
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-10-31 17:26:29
     */
    previousHandle() {
      this.blackNum++;
      this.optionIndex--;
    },
    /*
     *@param: 
     *@return: 
     *@Description: 初始化方法
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-01 18:12:40
    */
    pullData(bool){
      let count = 1;
      let idx = 0;
      // 去掉无选项的标题，计算一共多少道题目
      this.list.forEach((item,index)=>{
        if(bool){
          if(this.questObj[String(item.cid) + String(item.id)]){
            this.selectQuestionArray[index] = this.questObj[String(item.cid) + String(item.id)];
          }else if(getStorage(this.path, String(item.cid) + String(item.id))){
            this.questObj[String(item.cid) + String(item.id)] = getStorage(this.path, String(item.cid) + String(item.id));
            this.selectQuestionArray[index] = getStorage(this.path, String(item.cid) + String(item.id));
          }else{
            this.no_section.push(index);
          }  
          if(item.options){
            if((this.questObj[String(item.cid) + String(item.id)] && this.questObj[String(item.cid) + String(item.id)] !='title' ) || (getStorage(this.path, String(item.cid) + String(item.id)) && getStorage(this.$route.path, String(item.cid) + String(item.id))!='title')){
              count++;
            }
          }
          
        }
        // 如果当前对象里的options数组不为null
        if(item.options){
          idx++;
          this.questionCount++;
        }
        item['optionCount'] = idx;
        
      });
      // 向父组件触发一个函数
      this.$emit("questionsProgress",{
        questionCount:this.questionCount,
        
      });
      // 答案值的数组长度是否为0
      let selectArr = this.selectQuestionArray.length;
      if(this.no_section.length>0){
        // 数组的下标
        this.optionIndex =this.no_section[0];
        // 如回退步数
        this.blackNum = this.no_section[0];
      }else{
        this.optionIndex = selectArr>0?(selectArr>=this.list.length-1?selectArr-1:selectArr):0;
      }
    },
    /*
     *@param: bool
     *@Description: 是否读取进度
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-05 16:09:34
    */
    isGetStorage(bool){
      if(!bool){
        for(let i=0;i<this.list.length;i++){
          if(this.questObj[parseInt(String(this.list[i].cid) + String(this.list[i].id))]){
            this.$delete(this.questObj,parseInt(String(this.list[i].cid) + String(this.list[i].id)));
          }
        }
        this.selectQuestionArray = [];
        this.optionIndex = 0;
        // 提交删除缓存 
        deleteStorage(this.path);
      }
      this.pullData(bool);
      this.interruptShow = false;
      if(bool){
        this.answerSheetShow = false;
      }
    },
    /*
     *@Description: 测评答题说明页
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-11-05 16:28:24
    */
    sheetHandle(){
      // 测评答题说明页
      this.answerSheetShow = this.intro.length>0?true:false;
      // 测评答题说明页文案
      this.btnText = '好的，GO！';
      this.sheetList = this.intro && this.intro.length>0?this.intro:[
        `测试共${this.questionCount}题，预计用时10分钟左右，请您确保有足够的作答时间。`,
        "答案没有对错之分，如实作答即可；你的作答将得到严格保密。",
        "如果作答中中断，可以再次点击测试按钮即可进入答题页。"
      ];
    },
    /*
      *@param: 
      *@return: 
      *@Description: 更新测评进度
      *@MethodAuthor:  Zhang Xiao Guang
      *@Date: 2019-12-16 17:41:33
    */
    msProgress(){
      let percentage = Math.round((this.percentage>100?100:this.percentage)*10)/10;
      progress({
        cid:this.data_.cid,
        progress:percentage
      }).then(()=>{

      });
    },
    /*
     *@param: 
     *@return: 
     *@Description: 判断此模块是否有缓存
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2020-01-19 10:03:31
    */
    isStorage(bool){
      if(bool){
        // 去掉无选项的标题，计算一共多少道题目
        let b = false;
        for(let i=0;i<this.list.length;i++){
          if(this.questObj[(this.path, String(this.list[i].cid) + String(this.list[i].id))]){
            b=true;
            break;
          }else if(getStorage(this.path, String(this.list[i].cid) + String(this.list[i].id))){
            b=true;
            break;
          }
        }
        return b
      }
      return false
    },
    // 初始化
    initHandle(){
      let obj = getStorage('/an_questions3','anQuestArr');
      this.data_ = obj.data_;
      this.cid = obj.cid;
      this.index = obj.index;
      this.questObj= obj.questObj;
      this.path = obj.path;
      this.list = !obj.array?[]:obj.array;
      this.interruptShow = this.isStorage(obj.interruptShow);
      this.intro = obj.intro;
      this.title = obj.title;
      this.routeIdx = this.$route.query.idx;
      if(this.data_ && String(this.data_.code)!=10002){
        // 重新答题或没有缓存
        if(!this.interruptShow){
          this.pullData();
        }
        this.sheetHandle();
      }else{
        this.$toast(this.data_.data.msg);
      }
    },
    //页面销毁时调用或答完题
    saveData_(){
      if(this.boolQes){
          // 销毁定时器
        window.clearInterval(this.ms_progress);

        // 请求进度接口
        saveData({
          cid:this.cid,
          data:String(this.questObj)!='{}'&&this.questObj?JSON.stringify(this.questObj):''
        }).then((data)=>{

        });
      }
    }
  },
  destroyed(){
    this.isRepoer(true);
  },
  mounted(){
    this.ms_progress = window.setInterval(()=> {
      this.msProgress();
    },10000)
  },
  created(){
    this.initHandle();
  }
};
</script>

<style lang="scss" scoped>
.answer-questions {
  padding: 34px 30px 140px;
  text-align: center;
  p.small{
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    font-size:16px;
    color:#999999;
  }
  // 弹出开始测评说明
  .answer-sheet {
    transition: all 2s;
    position: fixed;
    z-index: 998;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 750px;
    height: 100%;
    overflow: auto;
  }
  .answer-sheet.on {
    left: -750px;
  }
  .questions-container {
    box-shadow: 0px 1px 8px 2px rgba(235, 80, 50, 0.14);
    border-radius: 12px;
    padding: 35px 30px;
    margin-bottom: 60px;
    // min-height: 800px;
    position: relative;
    .questions-progress {
      padding-bottom: 35px;
      border-bottom: 2px solid #f0f0f0;
      display: flex;
      align-items: center;
      label {
        font-size: 32px;
        color: #eb5032;
      }
      .progress {
        margin-left: auto;
        flex: 1;
        border-radius: 5px;
        overflow: hidden;
        margin-left: 30px;
      }
    }
    .questions-title {
      color: #333333;
      text-align: left;
      .title {
        font-size: 36px;
        font-weight: bold;
        margin: 40px auto 100px;
      }
      .radio {
        display: flex;
        margin-bottom: 55px;
        font-size: 32px;
        line-height: 46px;
        .van-icon.van-icon-success {
          background-color: #eb5032;
          border-color: #eb5032;
          &::before {
            content: "";
          }
        }
      }
    }
    .btn-group-on{
      position: absolute;
      bottom: 60px;
      width: 630px;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      .nextBtn {
        line-height: 64px;
        height: 64px;
        color: #ffffff;
        background: #eb5032;
        border: none;
        width: 348px;
        font-size: 32px;
        margin-left: auto;
        border-radius: 32px;
      }
      .previousBtn-on {
        line-height: 64px;
        height: 64px;
        color: #eb5032;
        background: #ffffff;
        border: 2px solid #eb5032;
        width: 174px;
        font-size: 32px;
        border-radius: 32px;
      }
    }
    
    .he-review{
      font-size: 36px;
      text-align: left;
      ul li{
        margin-bottom: 30px;
      }
    }
  }
  .btn-group{
    display: flex;
    justify-content: center;
    padding: 0 34px;
    box-sizing: border-box;
    .reportBtn{
      line-height: 64px;
      height: 64px;
      margin-left: auto;
      width: 348px;
      color: #ffffff;
      background: #eb5032;
      border: none;
      font-size: 32px;
      border-radius: 32px;
    }
    .nextBtn {
      line-height: 64px;
      height: 64px;
      color: #ffffff;
      background: #eb5032;
      border: none;
      width: 348px;
      font-size: 32px;
      margin-left: auto;
      border-radius: 32px;
    }
    .previousBtn{
      line-height: 64px;
      height: 64px;
      width: 174px;
      color: #eb5032;
      background: #ffffff;
      border: 2px solid #eb5032;
      font-size: 32px;
      border-radius: 32px;
    }
  }
  .confirm_box {
    h2 {
      padding: 40px 30px;
    }
    h2.on{
      padding: 60px 30px;
    }
    p {
      margin-bottom: 50px;
      font-size: 26px;
      color: #666;
    }
    .btn_group {
      .confirm{
        color: #999999;
      }
      .cancel{
        color:#EB5032;
      }
    }
  }
  
}
</style> 

<style lang="scss">
body {
  background: #ffffff;
}
.van-toast--default{
  text-align: justify;
}
.answer-questions .questions-title .radio.on{
  transition: all .5s;
  .van-radio__label{
    color:#eb5032;
    font-weight: bold;
  }
}
.answer-questions .questions-title .radio {
  display: flex;
  margin-bottom: 53px;
  .van-radio__icon .van-icon {
    margin-top: 6px;
    width: 30px;
    height: 30px;
  }
  .van-radio__label{
    line-height: 46px;
  }
  .van-radio__icon--checked .van-icon.van-icon-success {
    background-color: #eb5032;
    border-color: #eb5032;
    &::before {
      content: "";
    }
  }
}
</style>